import { client } from ".";

async function fetchPage(page: number) {
	const { data } = await client.get<ResultList<Country>>(`/countries`, {
		params: { page },
	});
	return data;
}

async function store(item: StoreCountry) {
	const { data } = await client.post<Result<Country>>("/countries", item);
	return data;
}

async function update(id: number, item: StoreCountry) {
	const { data } = await client.put<Result<Country>>(`/countries/${id}`, item);
	return data;
}

async function destroy(id: number) {
	const { data } = await client.delete(`/countries/${id}`);
	return data;
}

const countriesAPI = {
	fetchPage,
	store,
	update,
	destroy,
};

export default countriesAPI;
